import './NewClientLabel.scss';

import { Tooltip } from '@mui/material';

import Icon from 'atoms/icon';

export function NewClientLabel({ variant }) {
  return (
    <Tooltip
      title="New client"
      className="new-client-label flex-row align-center"
    >
      <div>
        <Icon
          name="newClient"
          style={{ fill: variant === 'white' ? '#FFF' : '#FF9838' }}
        />
      </div>
    </Tooltip>
  );
}
